import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip,
    Button,
    Typography,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useNavigate } from "react-router-dom";
import { IContratoPagedResponse } from "models/response/contrato-paged-response";
import { PaginationResponse } from "models/pagination-response";
import { getCategoryColor } from "utils/category-colors";

type ContratosTableProps = {
    currentItems: PaginationResponse<IContratoPagedResponse>;
};

export const ContratosTable: React.FC<ContratosTableProps> = ({ currentItems }) => {
    const navigate = useNavigate();

    if (!currentItems?.hasItems()) {
        return <Typography variant="body1">Nenhum contrato encontrado.</Typography>;
    }

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Nº Contrato</TableCell>
                        <TableCell>Fornecedor</TableCell>
                        <TableCell>Tipo</TableCell>
                        <TableCell>Situação</TableCell>
                        <TableCell>Data Assinatura</TableCell>
                        <TableCell>Vigência Início</TableCell>
                        <TableCell>Vigência Fim</TableCell>
                        <TableCell align="right">Valor</TableCell>
                        <TableCell align="center">Detalhes</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {currentItems.items.map((contrato) => (
                        <TableRow key={contrato.id}>
                            <TableCell>{contrato.numContrato}</TableCell>
                            <TableCell>{contrato.fornecedorName}</TableCell>
                            <TableCell>
                                <Chip label={contrato.tipoContratoName} size="small" style={getCategoryColor(contrato.tipoContratoName)} />
                            </TableCell>
                            <TableCell><Chip label={contrato.situacaoContratoName} size="small" /></TableCell>
                            <TableCell>{new Date(contrato.dtaAssinatura).toLocaleDateString('pt-BR')}</TableCell>
                            <TableCell>{new Date(contrato.dtaInicioVigencia).toLocaleDateString('pt-BR')}</TableCell>
                            <TableCell>{new Date(contrato.dtaFimVigencia).toLocaleDateString('pt-BR')}</TableCell>
                            <TableCell align="right">
                                {contrato.valorContrato?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                            </TableCell>
                            <TableCell align="center">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<VisibilityIcon />}
                                    onClick={() => navigate(`/contratos/${contrato.id}`)}
                                >
                                    Detalhes
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
